import _i18n from '@/utilities/I18n'

const i18n = _i18n.global

/**
 * Returns a date as a formatted string
 * @param date The date to represent
 * @param format Formatting, accepting: yyyy, MMM, MM, M, dd, d, hh, h, mm, m, ss, s, w, v
 * @returns The formatted date
 */
export function formatDate(value?: Date, format?: string) {
	if (value) {
		if (!format) { format = 'dd-MM-yyyy hh:mm' }
		return _formatDate(value, format)
	}
}

/**
 * Returns a date as a formatted string
 * @param date The date to represent
 * @param format Formatting, accepting: yyyy, MMM, MM, M, dd, d, hh, h, mm, m, ss, s, w, v
 * @returns The formatted date
 */
function _formatDate(date: Date, format: string) {
	const parts: string[] = []
	let buffer = ''

	for (let index = 0; index < format.length; index++) {
		buffer += format[index]
		if (format[index] != format[index + 1]) {
			parts.push(buffer)
			buffer = ''
		}
	}

	return parts.map(part => {
		if (part === 'yyyy') { return date.getFullYear().toString() }
		else if (part === 'MMM') { return i18n.t(`common.month-long.${date.getMonth()}`) }
		else if (part === 'MM') { return (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : date.getMonth() + 1) }
		else if (part === 'M') { return (date.getMonth() + 1).toString() }
		else if (part === 'dd') { return (date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate()) }
		else if (part === 'd') { return date.getDate().toString() }
		else if (part === 'hh') { return (date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours()) }
		else if (part === 'HH') { return (date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours()) }
		else if (part === 'h') { return date.getHours().toString() }
		else if (part === 'mm') { return (date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes()) }
		else if (part === 'm') { return date.getMinutes().toString() }
		else if (part === 'ss') { return (date.getSeconds() < 10 ? '0' + date.getSeconds().toString() : date.getSeconds()) }
		else if (part === 's') { return date.getSeconds().toString() }
		else if (part === 'w') { return i18n.t(`common.day-long.${date.getDay()}`) }
		else if (part === 'v') { return i18n.t(`common.day-short.${date.getDay()}`) }
		else { return part }
	}).join('')
}

// Pretty prints durations
// zeroO if true converts all zero's to O's - used with monospace RobotoMono font
// minMin if true and time is less than a minute, 0: is prefixed
/**
 * Format a number of seconds as a duration
 * @param value Number to format
 * @param zeroO If true converts all zero's to O's - used with monospace RobotoMono font
 * @param minMin If true and time is less than a minute, 0: is prefixed
 * @returns Formatted duration
 */
export function duration(value?: number, zeroO = false, minMin = false) {
	if (value == null || value == undefined || value < 0) { return '' }

	const pad = function(string: number, pad: number, length: number) {
		return (new Array(length + 1).join(`${pad}`) + `${string}`).slice(-length)
	}

	const hours = Math.floor(value / 60 / 60)
	const minutes = Math.floor((value - (hours * 60 * 60)) / 60)
	const seconds = value - (hours * 60 * 60) - (minutes * 60)
	let res = ''

	if (hours) { res = `${hours}:${pad(minutes, 0, 2)}:${pad(seconds, 0, 2)}` }
	else if (minutes) { res = `${minutes}:${pad(seconds, 0, 2)}` }
	else { res = `${seconds}` }

	if (minMin && !minutes) {
		if (Number(res) < 10) { res = '0' + res }
		res = '0:' + res
	}

	if (zeroO) {
		res = res.replace(/0/g, 'O')
	}

	return res
}

/**
 * Format a number of seconds as a short duration
 * @param value Duration to format
 * @param label True to return the label, false to return the duration
 * @returns Formatted duration or label
 */
export function shortduration(value?: number, label = false) {
	if (value == null || value < 0) { return '' }

	const hours = Math.floor(value / 60 / 60)
	const minutes = Math.floor((value - (hours * 60 * 60)) / 60)
	const seconds = Math.floor(value - (hours * 60 * 60) - (minutes * 60))
	let res = ''
	let reslabel = ''
	if (hours) {
		const time = hours + Number((25 / 60).toString().substring(0, 3))

		res = `${time}`
		reslabel = time > 1 ? i18n.t('common.hours') : i18n.t('common.hour')
	}
	else if (minutes) {
		res = `${minutes}`
		reslabel = i18n.t('common.minutes-short')
	}
	else {
		res = `${seconds}`
		reslabel = i18n.t('common.seconds-short')
	}

	if (label) { return reslabel } else { return res }
}
